import { luscinia } from "../luscinia";
import "./closeModal";
import { getActionFromUrl, ModalRenderedDetail } from "../initializer";
import { handleRedirection } from "../Utils/handleRedirection";
import { buildDownloadReportAndEmailFormData } from "../downloadReportEmail";
import { buildSendReportEmailFormData } from "../sendReportEmail";
import { Tab } from "bootstrap";

//declare var bootstrap: any;

// Initialize the javascript enhanced controls on the modal dialog for editing records
luscinia.initModalDialog = function (form, modalIdentifier, config, modalAction, filter = undefined, inline = false, elementIdentifer = undefined, customSerializer = undefined) {
    // prevent submit on enter
    form.on("submit", function (e) {
        return false;
    });
    $(modalIdentifier.slice(0, -1) + (luscinia.getModalLayerCount() - 1)).keyup('keyup.Escape', function (e) {
        if (e.key === "Escape") {
            luscinia.closeModal();
        }
    });

    // Remove modal dialog inner html on modal dialog close
    if (!inline) {
        $(modalIdentifier).on("hidden.bs.modal", function (e) {
            $(e.target).removeData("bs.modal");
        });
    }

    if (elementIdentifer !== undefined) {
        $(form).data("calling-element-id", elementIdentifer)
    }

    // Add event handler to set focus to first input
    $(modalIdentifier).on('shown.bs.modal', function () {
        $(modalIdentifier).modal("handleUpdate");
        $(modalIdentifier + ' .modal-body :input:enabled:visible:first').each(function () {
            $(this).focus();
            luscinia.SetCaretAtEnd(this as HTMLInputElement);
        });
    });

    // Optionally set filter for limiting form items
    if (filter === undefined) {
        filter = form;
    }

    var formIsDonePromise = luscinia.initFormElements(filter, form).then(function () {
        var modulePath = $(form).data(luscinia.data.modulePath);
        if (modulePath !== null && modulePath !== undefined) {
            var formData = customSerializer ? customSerializer($(form)) : luscinia.serializeFormObject($(form));
            $.ajax({
                method: "POST",
                processData: false,
                contentType: false,
                url: modulePath + `/modalafteropen?action=${encodeURIComponent(modalAction)}`,
                data: formData
            }).done(function (actions) {
                luscinia.executeActionList(actions, form, false);
                $(form).attr("loaded", "true");
            });
        }
    });

    // Set iframe url to data-url attribute on tab change
    $(filter).find("a[data-toggle='tab']").on("shown.bs.tab", function (e) {
        $("#tab-modal-" + (e.target as any).href[(e.target as any).href.length - 1]).find('iframe').each(function () {
            var iframe = $(this);
            if (iframe.data("src")) { // only do it once per iframe
                iframe.prop("src", iframe.data("src"));
                iframe.data("src", false);
            }
        });
        luscinia.getCurrentModal().modal("handleUpdate");
    });

    $(form).closest(".edit-modal").find("[" + luscinia.css.postElementUrl + "]").on("click", function () {
        luscinia.postFormData($(this).attr(luscinia.css.postElementUrl), form);
    });

    luscinia.initUpdateJobOverview(filter);

    return formIsDonePromise;
};

luscinia.initNumberSliders = function (filter) {
    // Init NumberSlider
    ($(filter).find(".bslider") as any).slider();
};

luscinia.initCheckboxSwitches = function (filter) {
    // Init CheckboxSlider
    ($(filter).find(".bswitch") as any).bootstrapSwitch().on("switchChange.bootstrapSwitch", function (event, state) {
        $(this).trigger("change");
    });
};

luscinia.getModalLayerCount = function () {
    return $(".edit-modal").length;
};

luscinia.getCurrentModal = function () {
    return $("#editModal" + (luscinia.getModalLayerCount() - 1));
};

// Edit modal function for new records
luscinia.openCustomModalNew = function (url, element) {
    url = `${url}/modaledit?action=new&layerid=${luscinia.getModalLayerCount()}`;
    $.get(url, function (data) {
        var modalIdentifier = "#editModal" + luscinia.getModalLayerCount();
        $("#cl-wrapper").append(data);
        luscinia.initModalDialog($(modalIdentifier + "Form"), modalIdentifier, luscinia.config, getActionFromUrl(url), undefined, false, element);
        $(modalIdentifier).modal("show");

        document.dispatchEvent(new CustomEvent<ModalRenderedDetail>('modalRendered', {
            detail: {
                recordTableName: url.replace("/data/", ""),
                modalIdentifier: modalIdentifier,
            }
        }));
    }).fail(function () {
        luscinia.showNotification(luscinia.config.translations.captionNotification, luscinia.config.translations.captionNotificationForbidden, "danger");
    });
};

// Edit modal function to work without bootgrid, rebind delete button on modal too
luscinia.openCustomModalEdit = function (url, id, queryparameter = "") {
    let modalUrl = url + "/modaledit?action=edit&id=" + id + "&layerid=" + luscinia.getModalLayerCount() + (queryparameter !== "" ? `&${queryparameter}` : "");
    return $.get(modalUrl, function (data) {
        var modalIdentifier = "#editModal" + luscinia.getModalLayerCount();
        $("#cl-wrapper").append(data);
        luscinia.initModalDialog($(modalIdentifier + "Form"), modalIdentifier, luscinia.config, getActionFromUrl(url));
        $(modalIdentifier).modal("show");

        document.dispatchEvent(new CustomEvent<ModalRenderedDetail>('modalRendered', {
            detail: {
                recordTableName: modalUrl.replace("/data/", ""),
                modalIdentifier: modalIdentifier,
            }
        }));
        
        // Rebind delete click event to work without calling the bootgrid delete event
        $(modalIdentifier + "FormDelete").unbind("click").bind("click", { url: url, id: id }, function (event) {
            luscinia.showConfirmationDialog(luscinia.config.translations.captionConfirmDeleteRecordTitle, luscinia.config.translations.captionConfirmDeleteRecord, function (e) {
                let confirmed = $(e.target).data(luscinia.data.value) === true;
                if (confirmed) {
                    $.ajax({
                        type: "DELETE",
                        url: event.data.url.toLowerCase() + "/" + event.data.id,
                        success: function (data) {
                            luscinia.showNotification(luscinia.config.translations.captionNotification, luscinia.config.translations.captionNotificationRecordDeleted, "warning");
                            const recordDeletedEvent = new CustomEvent("recordDeleted", { detail: { id: id } });
                            document.dispatchEvent(recordDeletedEvent);
                        }, error: function (jqXHR, textStatus, errorThrown) {
                            luscinia.showNotification(luscinia.config.translations.captionNotification, luscinia.config.translations.captionNotificationRecordDeleteFailed, "danger");
                        }
                    });
                }
            });
        });
    }).fail(function () {
        luscinia.showNotification(luscinia.config.translations.captionNotification, luscinia.config.translations.captionNotificationForbidden, "danger");
    });
};

const UPLOAD_PROGRESS_THRESHOLD_BYTES = 1024 * 1024; // 1 MB

function getTotalFileBytes(formData: FormData): number {
    let total = 0;
    formData.forEach((value) => {
        if (value instanceof File) {
            total += value.size;
        }
    });
    return total;
}

// Handles click event on save button on the modal dialog used for editing records
luscinia.editModalFormSaveClick = function (sender, callback, closeModal, redirect, newTab = false) {
    const modal = sender.closest("#editModalContent");
    let frmSelector: string;
    let frm: JQuery<HTMLFormElement>;
    if (modal) {
        const form = modal.querySelector("form")
        frmSelector = form.id;
        frm = $(form) as JQuery<HTMLFormElement>;
    }
    else {
        frmSelector = "#editModal" + (luscinia.getModalLayerCount() - 1) + "Form";
        frm = $(frmSelector) as JQuery<HTMLFormElement>;
    }
    if (sender !== undefined) {
        $(sender).prop("disabled", true);
    }

    var ajaxType = $("[name='AjaxType']", frm).val() as string;
    var formData = luscinia.serializeFormObject(frm);

    let progressEl: HTMLElement | null = null;
    if (getTotalFileBytes(formData) >= UPLOAD_PROGRESS_THRESHOLD_BYTES) {
        const footer = sender.closest('.modal-footer');
        if (footer) {
            const progressHtml = `<div class="luscinia-upload-progress w-100 mb-1">
                <small class="text-muted luscinia-upload-progress-label">Uploading...</small>
                <div class="progress mt-1" style="height: 5px;">
                    <div class="progress-bar progress-bar-striped progress-bar-animated bg-primary"
                         role="progressbar" style="width: 0%" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100">
                    </div>
                </div>
            </div>`;
            $(footer).prepend(progressHtml);
            progressEl = footer.querySelector('.luscinia-upload-progress') as HTMLElement;
        }
    }

    $.ajax({
        method: ajaxType,
        url: frm.attr("action"),
        cache: false,
        contentType: false,
        processData: false,
        data: formData,
        xhr: function () {
            const xhr = new XMLHttpRequest();
            if (progressEl) {
                xhr.upload.addEventListener('progress', function (e) {
                    if (e.lengthComputable) {
                        const percent = Math.round((e.loaded / e.total) * 100);
                        const bar = progressEl.querySelector('.progress-bar') as HTMLElement;
                        if (bar) {
                            bar.style.width = percent + '%';
                            bar.setAttribute('aria-valuenow', percent.toString());
                        }
                        if (percent >= 100) {
                            const label = progressEl.querySelector('.luscinia-upload-progress-label');
                            if (label) label.textContent = 'Processing...';
                        }
                    }
                });
            }
            return xhr;
        },
        success: function (data) {
            if (progressEl) progressEl.remove();
            document.dispatchEvent(new CustomEvent<{ formData: FormData, recordName: string, recordId: string }>("lusciniaModalSaved", { detail: { formData: formData, recordName: frm.data("luscinia-modulepath").replace("/data/", ""), recordId: data[0] } }));

            // Remove errors in edit form, important if rendered inline
            var modalerror = $(frmSelector + "-luscinia-modal-message");
            var modalerrorText = modalerror.find(frmSelector + "-luscinia-modal-message-text");
            modalerror.hide();
            modalerrorText.text("");
            frm.find(".has-error").removeClass("has-error");
            frm.find(".help-block").text("");

            luscinia.showNotification(luscinia.config.translations.captionNotification, luscinia.config.translations.captionNotificationRecordSaved, "success");
            const recordSavedEvent = new CustomEvent("recordSaved", { detail: { id: data } });
            document.dispatchEvent(recordSavedEvent);
            $(sender).prop("disabled", false);
            if (closeModal === undefined || closeModal) {
                luscinia.closeModal();
                // refresh bootgrids
                $("#" + $("[name='LusciniaBootgridId']", frm).val()).each(function () {
                    luscinia.keepSelectionId = $(this).find("tr." + luscinia.css.rowSelected).data("row-id");                    
                    ($(this) as any).bootgrid("reload");                    
                    if (callback !== undefined) {
                        if (typeof data === "string") {
                            callback(data);
                        } else {
                            callback(data[0]);
                        }
                    }
                });
                // refresh ajax select controls
                const callingFormSelector = "#editModal" + (luscinia.getModalLayerCount() - 2) + "Form";
                $(callingFormSelector).find(`input.${luscinia.css.ajaxSelect}`).each(function () {
                    var element = $(this);
                    if (element.data('select2')) {
                        (element as any).select2("destroy");
                    }
                    luscinia.initializeAjaxSelect2(element);
                });
                // set value of select2 if calling element is provided (Select2 4.x API)
                $(callingFormSelector).find("#" + frm.data("calling-element-id")).val(data).trigger("change");
            } else {
                if (callback !== undefined) {
                    if (typeof data === "string") {
                        callback(data);
                    } else {
                        callback(data[0]);
                    }
                }
            }
            if (redirect !== "" && redirect !== undefined) {
                handleRedirection(redirect, data, newTab);
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            if (progressEl) progressEl.remove();
            $(sender).prop("disabled", false);

            if (jqXHR.status === 413) {
                luscinia.showNotification(
                    luscinia.config.translations.captionNotificationRequestTooLarge,
                    luscinia.config.translations.captionNotificationRequestTooLargeDescription,
                    "danger"
                );
                return;
            }

            let errorMessageOrErrorList = jqXHR.responseJSON !== undefined ? jqXHR.responseJSON : jqXHR.responseText;
            var showTabInput = luscinia.refreshValidation(errorMessageOrErrorList, frm, frmSelector);

            // Make tab active for first element that has an error
            if (showTabInput !== undefined) {
                var firstTab = $(".nav a[href='#" + $(showTabInput).closest(".tab-pane").attr("id") + "']").first();
                if(firstTab.length === 1){
                    var mytab = new Tab($(".nav a[href='#" + $(showTabInput).closest(".tab-pane").attr("id") + "']")[0]);
                    mytab.show();
                    showTabInput.focus();
                }
            }
        }
    });
};

// Back to url (not using browser back)
luscinia.editModalFormCancel = function () {
    var redirectURL = location.protocol + "//" + location.hostname + ":" + location.port + location.pathname;
    if (redirectURL.toLowerCase().endsWith("record")) {
        redirectURL = redirectURL.substring(0, redirectURL.length - 6);
    }
    (window.location as any) = redirectURL;
};

luscinia.openCustomModal = function (url, query) {
    var getUrl = url + `/${luscinia.getModalLayerCount()}`;
    if (query !== undefined) {
        getUrl += "?" + query;
    }
    return $.get(getUrl, function (data) {
        //Retrieve Identifier BEFORE adding the data to the form
        var modalIdentifier = "#editModal" + luscinia.getModalLayerCount();
        data = getAutoFilledData(data);
        $("#cl-wrapper").append(data);
        luscinia.initModalDialog($(modalIdentifier + "Form"), modalIdentifier, luscinia.config, getActionFromUrl(getUrl), modalIdentifier);
        $(modalIdentifier).modal("show");
    });
};

luscinia.openSendReportEmailModal = async function(isSend = true) {
    let url = isSend ? "/send-report-email" : "/download-report-email"
    const reportParameterFormData = luscinia.serializeFormObject($(".modal-form"));
    const reportParameterClassName = $(".modal-form").data("parameter-class-name");

    url = `${url}/modal/${reportParameterClassName}/${luscinia.getModalLayerCount()}`;
    const result = await fetch(url, {
        method: "POST",
        body: reportParameterFormData
    })

    const data = await result.text();

    var modalIdentifier = "#editModal" + luscinia.getModalLayerCount();
    $("#cl-wrapper").append(data);
    luscinia.initModalDialog($(modalIdentifier).find("form"), modalIdentifier, luscinia.config, getActionFromUrl(url), modalIdentifier, undefined, undefined, isSend ? buildSendReportEmailFormData : buildDownloadReportAndEmailFormData);
    $(modalIdentifier).modal("show");
}

luscinia.openCustomReportModal = async function (url) {
    url = `${url}/${luscinia.getModalLayerCount()}`;

    const mainBootgrid = $(`.${luscinia.css.bootgrid}[data-luscinia-filtercolumnname=""]`).not('.tab-pane *') as any;
    const visibleSubBootgrid = $(`.tab-pane.active .${luscinia.css.bootgrid}`).first() as any;
    const body = {
        keyColumnName: mainBootgrid.data("luscinia-keycolumnname"),
        selectedRowIds: mainBootgrid.bootgrid("getSelectedRowIds"),
        subKeyColumnName: visibleSubBootgrid.length ? visibleSubBootgrid.data("luscinia-keycolumnname") : null,
        subSelectedRowIds: visibleSubBootgrid.length ? visibleSubBootgrid.bootgrid("getSelectedRowIds") : []
    }

    const response = await fetch(url, {
        method: "POST",
        body: JSON.stringify(body)
    });

    if (response.ok) {
        var modalIdentifier = "#editModal" + luscinia.getModalLayerCount();
        let data = await response.text();
        data = getAutoFilledData(data);
        $("#cl-wrapper").append(data);
        luscinia.initModalDialog($(modalIdentifier + "Form"), modalIdentifier, luscinia.config, getActionFromUrl(url), modalIdentifier);
        $(modalIdentifier).modal("show");
    }
    else
    {
        console.error(response);
    }
}

luscinia.submitForm = function (event) {
    event.preventDefault();
    // Submit the form that actually raised the submit event, rather than guessing
    // "#editModal{layerCount-1}Form". Not every form using this handler follows that id scheme - the
    // reset-pincode parameter form is "inlineModal0Form", so the guessed selector matched nothing,
    // frm was empty and frm.attr("data-url") was undefined -> "Cannot read properties of undefined
    // (reading 'toString')". event.currentTarget is the <form> the onsubmit is bound to.
    let frm = $(event.currentTarget || event.target) as JQuery<HTMLFormElement>;
    let frmSelector = frm.attr("id") ? "#" + frm.attr("id") : "form";
    var formData = luscinia.serializeFormObject(frm);

    let url = frm.attr("data-url").toString();
    $.ajax({
        method: "POST",
        url: url,
        data: formData,
        cache: false,
        contentType: false,
        processData: false,
        success: function (data) {
            luscinia.closeModal();
            luscinia.showNotification(luscinia.config.translations.captionNotification, luscinia.config.translations.captionNotificationEmailSent, "success");
        },
        error: function (jqXHR, textStatus, errorThrown) {
            let errorMessageOrErrorList = jqXHR.responseJSON !== undefined ? jqXHR.responseJSON : jqXHR.responseText;
            var showTabInput = luscinia.refreshValidation(errorMessageOrErrorList, frm, frmSelector);

            // Make tab active for first element that has an error
            if (showTabInput !== undefined) {
                var firstTab = $(".nav a[href='#" + $(showTabInput).closest(".tab-pane").attr("id") + "']").first();
                if(firstTab.length === 1){
                    var mytab = new Tab($(".nav a[href='#" + $(showTabInput).closest(".tab-pane").attr("id") + "']")[0]);
                    mytab.show();
                    showTabInput.focus();
                }
            }
        }     
    });
};


function getAutoFilledData(data: string): string {
    const parser = new DOMParser();
    const doc = parser.parseFromString(data, "text/html");
    const autoFillAjaxInput = doc.querySelector('input.luscinia-ajax-select[luscinia-parameter-autofill]');
    if (!autoFillAjaxInput) {
        return data;
    }
    const columnId = autoFillAjaxInput.getAttribute('name').replace('parameter-', '');
    const autoFillTable = document.querySelector(`table.luscinia-bootgrid[data-luscinia-keycolumnname="${columnId}"]`);
    if (autoFillTable) {
        const autoFillValue = autoFillTable.querySelector('tbody > tr.row_selected').getAttribute('data-row-id');
        autoFillAjaxInput.setAttribute('value', autoFillValue);
    }

    return doc.body.innerHTML;
}

export function getFormObject(formData: FormData) {
    let formObject: object = {};
    formData.forEach((value, key) => {
        formObject[key] = value;
    });
    return formObject;
}